import { render, staticRenderFns } from "./DepositCollection.vue?vue&type=template&id=95d99574&scoped=true&"
import script from "./DepositCollection.vue?vue&type=script&lang=js&"
export * from "./DepositCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d99574",
  null
  
)

export default component.exports